//bus.js
import Vue from 'vue'
export default new Vue()


// WEBPACK FOOTER //
// ./src/components/bus.js